import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { ProtectedRouteHook } from './hook/auth/ProtectedRouteHook';
import react, { Suspense, useEffect, lazy } from 'react';
import NavBarLogin from './Components/Utilities/NavBarLogin';
import LoginPage from './Pages/Auth/LoginPage';
import AllUsersPage from './Pages/users/AllUsersPage';
import AddUserPage from './Pages/users/AddUserPage';
import EditUserPage from './Pages/users/EditUserPage';
import AllPermissionsGroupsPage from './Pages/permissions/AllPermissionsGroupsPage';
import EditPermissionsPage from './Pages/permissions/EditPermissionsPage';
import AddMaketingUserPage from './Pages/marketing/AddMaketingUserPage';
import { ToastContainer } from 'react-toastify';
import HomePage from './Pages/home/HomePage';
import { ProtectedRoute } from './Components/Utilities/ProtectedRoute';
import { getAllPermissionTypes, getUserScreens } from './redux/slices/permissions/thunk';
import AccountantWithDrawPage from './Pages/withDraws/AccountantWithDrawPage';
import SalesRebort from './Components/members/Sales-Report/SalesReport';
import SendOrderSuccessfully from './Components/SendOrderSuccessfully/SendOrderSuccessfully';
import FailedToSendOrder from './Components/SendOrderSuccessfully/FailedToSendOrder';
import { getAllUsers, getLiquidationUsers } from './redux/slices/users/thunk';
import { useDispatch } from "react-redux";
import MaintenancePage from './Pages/Maintenance/MaintenancePage';
import { Spinner } from 'react-bootstrap';
import { getSmsLinkByID } from './redux/slices/banks/thunk';
import BackupsPage from './Pages/Backup/BackupsPage';
const AllOffersPage = lazy(() => import('./Pages/offers/AllOffersPage'));
const SettingsPage = lazy(() => import('./Pages/settings/SettingsPage'));
const BanksPage = lazy(() => import('./Pages/settings/banks/BanksPage'));
const AllOrdersPage = lazy(() => import('./Pages/orders/AllOrdersPage'));
const NewOrderPage = lazy(() => import('./Pages/orders/NewOrderPage'));
const ProfilePage = lazy(() => import('./Pages/settings/profile/ProfilePage'));
const AllMembersPage = lazy(() => import('./Pages/members/AllMembersPage'));
const AddOrderPage = lazy(() => import('./Pages/orders/AddOrderPage'));
const EditOrderPage = lazy(() => import('./Pages/orders/EditOrderPage'));
const MedicalSystemPage = lazy(() => import('./Pages/Medical-system/MedicalSystemPage'));
const CheckMemberShipPage = lazy(() => import('./Pages/members/CheckMemberShipPage'));
const AddMemberPage = lazy(() => import('./Pages/members/AddMemberPage'));
const MemberDetailsPage = lazy(() => import('./Pages/members/MemberDetailsPage'));
const AllDepositesPage = lazy(() => import('./Pages/deposites/AllDepositesPage'));
const ArchivesDepositesPage = lazy(() => import('./Pages/deposites/ArchivesDepositesPage'));
const AddDepositePage = lazy(() => import('./Pages/deposites/AddDepositePage'));
const AllLiquidationPage = lazy(() => import('./Pages/liquidation/AllLiquidationPage'));
const EditLiquidationPage = lazy(() => import('./Pages/liquidation/EditLiquidationPage'));
const WalletPage = lazy(() => import('./Pages/wallet/WalletPage'));
const ReportPage = lazy(() => import('./Pages/marketing/ReportPage'));
const PillMemberPage = lazy(() => import('./Pages/members/PillMemberPage'));
const UserSummaryPage = lazy(() => import('./Pages/user-summary/UserSummaryPage'));
const AddAndEditCountryPage = lazy(() => import('./Pages/AddAndEditCountryPage/AddAndEditCountryPage'));
const Cities = lazy(() => import('./Pages/Cities/Cities'));



function App() {
  const [isAuth] = ProtectedRouteHook();
  const dispatch = useDispatch();


  useEffect(() => {
    const loggedUser = JSON.parse(localStorage.getItem('user'));

    const get = async () => {
      let query = ``;
      if (loggedUser && !loggedUser.isAdmin) {
        query = `?father_id=${loggedUser._id}`;
        //محاسب
        if (!loggedUser.liquidation_user && !loggedUser.isAdmin) query = ``;
      }

      // مسوق
      if (loggedUser?.userMarketer && !loggedUser.liquidation_user && !loggedUser.isAdmin) {
        query = `?father_id=${loggedUser.father_id}`;
      }

      if (loggedUser?._id) {
        //console.log('ppppppppppppppppppppppppp')
        dispatch(getUserScreens(loggedUser?._id));
        dispatch(getAllPermissionTypes());
        // dispatch(getAllUsers(query));
        dispatch(getLiquidationUsers());
      }


          dispatch(getSmsLinkByID("66c5a5aa3aa099aa9c6f9880"));
      
    }

    get();
    // console.log('ppppppppppppppppppppppppp')
    // dispatch(getUserScreens(loggedUser?._id));


  }, []);


  // if(loggedUser==null) return window.location.href='/';

  return (

    <div className="font main-BG-Color">
      <BrowserRouter>
        <NavBarLogin />

        <Suspense fallback= { 
          <div className="spinner-overlay">
             <Spinner animation="border" role="status" variant="primary" />
          </div>
  } >

        <Routes>
        <Route index element={<LoginPage />} />

           {/* الصفحة الخارجية لتسجيل طلب جديدة */}
        <Route path='/orders/new' element={<NewOrderPage />} />
        <Route path='/Maintenance' element={<MaintenancePage />} />

          {/* صفحة التقرير هنا */}
          <Route path='/marketing/report' element={<ReportPage />} />
          <Route path='/check-member' element={<CheckMemberShipPage />} />

          {/* التسجيل */}
          <Route path='/SendOrderSuccessfully' element={<SendOrderSuccessfully />} />
          <Route path='/failedToSendOrder' element={<FailedToSendOrder />} />

          <Route element={<ProtectedRoute auth={isAuth} />} >
            
              <Route path='/home' element={<HomePage />} />

              <Route path='/users'>
                <Route index element={<AllUsersPage />} />
                <Route path='add' element={<AddUserPage />} />
                <Route path='edit/:id' element={<EditUserPage />} />
              </Route>

              <Route path='/permissions'  >
                <Route index element={<AllPermissionsGroupsPage />} />
                <Route path='edit/:id' element={<EditPermissionsPage />} />
              </Route>

              <Route path='/offers'>
                <Route index element={<AllOffersPage />} />
              </Route>

              <Route path='/orders'>
                <Route index element={<AllOrdersPage />} />
                <Route path='add' element={<AddOrderPage />} />
                <Route path='edit/:id' element={<EditOrderPage />} />
              </Route>

          
              <Route path='/marketing'>
                <Route index element={<AddMaketingUserPage />} />
              </Route>

              <Route path='/setting'>
                <Route path='' element={<SettingsPage />} />
                <Route path='banks' element={<BanksPage />} />
                <Route path='profile' element={<ProfilePage />} />
              </Route>

              <Route path='/members'>
                <Route index element={<AllMembersPage />} />
                <Route path='details/:id' element={<MemberDetailsPage />} />
                <Route path='pill/:id' element={<PillMemberPage />} />
                <Route path='salesRebort' element={<SalesRebort />} />
              </Route>

              <Route path='/new-member' element={<AddMemberPage />} />


              <Route path='/medical-system'>
                <Route index element={<MedicalSystemPage />} />
              </Route>

              <Route path='/deposites'>
                <Route index element={<AllDepositesPage />} />
                <Route path='add' element={<AddDepositePage />} />
              </Route>
              {/* deposites-archive */}

              {/* ارشيف الايداعات */}
              <Route path='/archive' element={<ArchivesDepositesPage />} />

              <Route path='/liquidation'>
                <Route index element={<AllLiquidationPage />} />
                <Route path='show/:id' element={<EditLiquidationPage />} />
              </Route>

              <Route path='/wallet'>
                <Route index element={<WalletPage />} />
              </Route>

              <Route path='/usersummary'>
                <Route index element={<UserSummaryPage />} />
              </Route>
              {/* currentTime */}
              <Route path='/countries'>
                <Route index element={<AddAndEditCountryPage />} />
                <Route path='cities/:id' element={<Cities />} />
              </Route>

              {/* طلبات السحب للمحاسب */}
              <Route path='/withDrawRequests' element={<AccountantWithDrawPage />} />
             
              {/* BackupsPage */}
              <Route path='/backups' element={<BackupsPage />} />
           
          </Route>

          </Routes>
        </Suspense>
      </BrowserRouter>

      <ToastContainer />
    </div>
  );
}

export default App;
